export enum PublisherWebhookEventTypes {
    OFFERS = 'offers',
    PRE_LOGIN = 'pre-login',
    POST_LOGIN = 'post-login',
}

export enum PublisherWebhookEventName {
    WEBSTORE_LOGIN_DISPLAYED = 'webstore.login.displayed',
    WEBSTORE_LOGIN_METHOD_SELECTED = 'webstore.login.login_method.selected',
    WEBSTORE_LOGIN_CANCELED = 'webstore.login.canceled',
    WEBSTORE_LOGIN_COMPLETED = 'webstore.login.completed',
    WEBSTORE_STORE_DISPLAYED = 'webstore.store.displayed',
    WEBSTORE_OFFERS_LOADED = 'webstore.offers.loaded',
    WEBSTORE_OFFERS_DISPLAYED = 'webstore.offers.displayed',
    WEBSTORE_OFFERS_TOOLTIP_OPENED = 'webstore.offers.tooltip.opened',
    WEBSTORE_POPUP_TRIGGERED = 'webstore.offers.popup_triggered',
    WEBSTORE_POPUP_CLOSED = 'webstore.offers.popup_closed',
    WEBSTORE_BADGE_CLICKED = 'webstore.offers.badge_clicked',
    WEBSTORE_APPROVAL_REQUEST_DISPLAYED = 'webstore.approval_request.displayed',
    WEBSTORE_APPROVAL_REQUEST_CLOSED = 'webstore.approval_request.closed',
}
